import { createElement } from "@wordpress/element";

/**
 * Internal dependencies
 */
import SaveShortcut from './save-shortcut';
export default function TextEditorGlobalKeyboardShortcuts() {
  return createElement(SaveShortcut, null);
}
//# sourceMappingURL=text-editor-shortcuts.js.map